import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

export default function SignUpFormGrid({ children }) {
  const items = Children.toArray(children);

  return (
    <Grid container size={12}>
      <Grid
        size={{
          sm: 8,
          xs: 12,
        }}
      >
        {items[0]}
      </Grid>
      <Grid
        size={{
          sm: 4,
          xs: 12,
        }}
      >
        {items[1]}
      </Grid>
    </Grid>
  );
}

SignUpFormGrid.propTypes = {
  children: PropTypes.node,
};
